export default function parseQrCode(qrString) {
  const gpsDataIndex = qrString.indexOf("105S") //The substring 105S is the start delimiter for the 3 following element: Heading, Latitude, Longitude
  const speedDataIndex = qrString.indexOf("%006") //The substring 006 is the start delimiter for the speed, in km/s
  const timeStampIndex = qrString.indexOf("007") //The substring 007 is the start delimiter for the the timestamp

  const result = {
    longitude: null,
    latitude: null,
    direction: null,
    speed: null,
    timestamp: null
  }
  
  if (gpsDataIndex !== -1) {
    const gpsData = qrString.slice(gpsDataIndex+4, gpsDataIndex+25)
    result.longitude = intToFloat(gpsData.slice(14,21))
    result.latitude = intToFloat(gpsData.slice(7,14))
    result.direction = intToFloat(gpsData.slice(0,7))
  }

  if (speedDataIndex !== -1) {
    const speedData = qrString.slice(speedDataIndex+4, speedDataIndex+11)
    const speedValue = intToFloat(speedData)
    if (Number.isSafeInteger(Math.round(speedValue)) && speedValue < 1000 && speedValue > -1) // this checks if the value could represent a speed in km/h, and is not derived from another "006" in the string
      result.speed = speedValue
  }

  if (timeStampIndex !== -1 && !!DataView.prototype.getBigUint64) { // Safari doesn't support this method
    const timeStampData = qrString.slice(timeStampIndex+3, timeStampIndex+17)
    result.timestamp = intToUint64(timeStampData)
  }

  function intToFloat(gpsDataSubstr) { //Each element is composed of 7 characters encoding a float in base36 format in little endian
    const buffer = new ArrayBuffer(4)
    let view = new DataView(buffer)
    const int = parseInt(gpsDataSubstr, 36)
    view.setInt32(0, int, true)
    return view.getFloat32(0)
  }

  function intToUint64(timeStampDataSubstr) {
    const lowerBits = timeStampDataSubstr.slice(7,14) // the last 7 the low part (bits 31-0) of the timestamp in nanoseconds
    const upperBits = timeStampDataSubstr.slice(0,7) // The first 7 are the high (bits 63-32) of the timestamp in nanoseconds
    const int1 = parseInt(upperBits, 36)
    const int2 = parseInt(lowerBits, 36)
    const buffer = new ArrayBuffer(8)
    let view = new DataView(buffer)
    view.setInt32(0, int1, true)
    view.setInt32(int1.length, int2, true)
    return Math.round(Number(view.getBigUint64(0)) / 1000000) //get the timestamp in unsigned long long converted to a microseconds timestamp
  }

  return result
}